// OK
// import axios from "axios";
import Properties from "../properties"
import apiClient from "../plugins/axios-instance";

const API_URL = "https://pelanggan." +Properties.DOMAIN_URL +"/api/v1";

export default class KodePosAPIService {
  constructor() {}
  static search = (input) =>
    apiClient.get(API_URL + "/kode-pos/" +input +"/limit/100", {
    });
  static getByID = (id) => apiClient.get(API_URL +"/kode-pos/" +id, {
  });
}
